import { highlightPlugin } from '@react-pdf-viewer/highlight';
import CustomHighlightTarget from './CustomHighlightTarget';

const createCustomHighlightPlugin = () => {
  const highlightPluginInstance = highlightPlugin({
    renderHighlightTarget: (props) => (
      <CustomHighlightTarget
        {...props}
        store={highlightPluginInstance.store}
      />
    ),
    renderHighlightContent: null, // No content to render for highlights
  });

  return highlightPluginInstance;
};

export default createCustomHighlightPlugin;
